import {
  IsNotEmpty,
  IsUUID,
  IsOptional,
  IsDateString,
  IsInt,
  IsBoolean,
  Min,
  IsArray,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { Type } from 'class-transformer'

export class CreateActivityTeachingAssignmentDto {
  @ApiProperty({
    description: "UUID de l'activité",
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsNotEmpty()
  @IsUUID('4')
  activityId!: string

  @ApiProperty({
    description: "UUID de l'enseignement",
    example: '660e8400-e29b-41d4-a716-446655440001',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  teachingId!: string

  @ApiPropertyOptional({
    description: 'Liste des UUIDs de leçons à valider',
    type: [String],
    example: ['660e8400-e29b-41d4-a716-446655440001'],
  })
  @IsOptional()
  @IsArray()
  @IsUUID('4', { each: true })
  lessonIds?: string[]

  @ApiPropertyOptional({
    description: 'Date de disponibilité (ISO 8601)',
    example: '2024-11-01T00:00:00Z',
    type: 'string',
  })
  @IsOptional()
  @IsDateString()
  availableFrom?: string

  @ApiPropertyOptional({
    description: "Date d'échéance (ISO 8601)",
    example: '2024-11-30T23:59:59Z',
    type: 'string',
  })
  @IsOptional()
  @IsDateString()
  dueAt?: string

  @ApiPropertyOptional({
    description: 'Nombre maximum de tentatives',
    example: 3,
    type: Number,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  maxAttempts?: number

  @ApiPropertyOptional({
    description: 'Afficher les solutions après soumission',
    default: false,
    type: Boolean,
  })
  @IsOptional()
  @IsBoolean()
  showSolutions?: boolean

  @ApiPropertyOptional({
    description: "Randomiser l'ordre des questions",
    default: false,
    type: Boolean,
  })
  @IsOptional()
  @IsBoolean()
  randomizeOrder?: boolean

  @ApiPropertyOptional({
    description: "Indique si l'assignation est visible",
    default: true,
    type: Boolean,
  })
  @IsOptional()
  @IsBoolean()
  isVisible?: boolean
}
